import i18n from '@/plugins/vuei18n'

export default {
    plank: {
        id: 'plank',
        label: i18n.t('items.type.plank')
    },
    joist: {
        id: 'joist',
        label: i18n.t('items.type.joist')
    },
    slat: {
        id: 'slat',
        label: i18n.t('items.type.slat')
    },
    additional: {
        id: 'additional',
        label: i18n.t('items.type.additional')
    },
    complementary: {
        id: 'complementary',
        label: i18n.t('items.type.complementary')
    },
    elevation: {
        id: 'elevation',
        label: i18n.t('items.type.elevation')
    },
    stair: {
        id: 'stair',
        label: i18n.t('items.type.stair')
    },
    corner: {
        id: 'corner',
        label: i18n.t('items.type.corner')
    }
}
